import { useState, useEffect } from 'react';

const hasWindow = typeof window !== 'undefined';

const getScrollPosition = () =>
  hasWindow ? { x: window.scrollX, y: window.scrollY } : { x: 0, y: 0 };

export const useScrollPosition = () => {
  const [position, setPosition] = useState(getScrollPosition);

  useEffect(() => {
    let requestRunning = null;
    const handleScroll = () => {
      if (hasWindow && requestRunning === null) {
        requestRunning = window.requestAnimationFrame(() => {
          setPosition(getScrollPosition());
          requestRunning = null;
        });
      }
    };
    if (hasWindow) {
      window.addEventListener('scroll', handleScroll);
    }
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return position;
};
